// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx","666":"component---src-pages-contact-form-jsx","956":"component---src-pages-typ-jsx"}[chunkId] + "-" + {"279":"d549766085fd1a800f65","415":"1128742c0b8e0e9e0b8a","666":"267779912bc9484097bb","956":"3cb103d7aa4ca7c9a80b"}[chunkId] + ".js";
};